import { Breadcrumb } from "@refinedev/mui";
import { Box } from "@mui/material";
import PageHeading from "../../components/pageHeading";
export const CYRCSTEMComputersSTEMClassesExecuted = () => {
  return (
    <Box>
      <Breadcrumb />
      <PageHeading heading="STEM classes executed" />
    </Box>
  );
};
